import { forwardRef } from "react";
import { useValidation } from "@/shared/forms";
import type { StringField as StringFieldProps } from "./types";

export const StringField = forwardRef<HTMLInputElement, StringFieldProps>(function StringField(
    { ariaLabel, value, onChange, required, minLength, placeholder, id, ...rest },
    ref,
) {
    useValidation(id, {
        errorLocation: "callout",
        rules: { required, ...(minLength != null && { minLength: { value: minLength } }) },
    });
    return (
        <input
            id={id}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required={required}
            aria-label={ariaLabel}
            placeholder={placeholder}
            ref={ref}
            {...rest}
        />
    );
});
